import { render } from "./ProfileIcon.vue?vue&type=template&id=d11bf0e8"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__